export var getMuiListOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            boxSizing: 'border-box',
        },
        padding: {
            paddingTop: spacing(0.25),
            paddingBottom: spacing(0.25),
        },
    });
};
//# sourceMappingURL=MuiList.js.map